<template>
    <div class="home-page">
		<Header></Header>
		<div class="content por">

      <div class="home-search disflex">
        <input ref="input" v-model="keywords" @blur="getSearch()"
          @keyup.enter.native="getSearch($event)" class="input" />
        <img @click="getSearch(keywords)" src="../../static/images/search-icon.png" />
      </div>
      <div class="home1 home1-bg ">
        <div class="por" style="margin-bottom:10px;">
          <div class="mission-t mt20" style="font-size:48px;">{{$t('FeaturedGames')}}</div>
          <div class="mt10">
              <img style="width:60%;" src="../../static/images/landing-x.png">
          </div>
        </div>
        <div class="home1-product">
          <div class="home1-list" v-for="(item,index) in info.recommend">
              <div class="name-title ovhidden" @click="goPlay(item.game_id)">
                {{item.title}}
              </div>
              <div class="home1-img" @click="goPlay(item.game_id)">
                <img :src="item.icon_image" />
              </div>
              <button class="btn btn-blue" @click="goPlay(item.game_id)">{{$t('play')}}</button>
          </div>
        </div>

      </div>
        <div class="home1-banner mt50">

        </div>
        <div class="home1-product2">
          <div class="product2-title mt30 disflex flex-between">
            <div class="title fw7">{{$t('Populargames')}}</div>
          </div>
          <div class="product2-content disflex">
            <div class="product2-list" v-for="(item,index) in info.hot">
                <div class="name-title ovhidden">
                  {{item.title}}
                </div>
              <div class="home1-img2" @click="goPlay(item.game_id)">
                <img :src="item.icon_image" />
              </div>
              <div class="product2-bottom" @click="goPlay(item.game_id)">
                <button class="btn btn-blue" @click="goPlay(item.game_id)">{{$t('play')}}</button>
              </div>
            </div>
          </div>

        </div>
        <div class="ac mt30">
          <div class="card-missions">
            <div class="" style="display: inline-block;padding-left: 80px;">
               <!-- <span class="font1 fs32 cra0d5dd">{{$t('cardMissions1')}}</span><span class="fs46 crffde19 font2">{{$t('cardMissions2')}}!</span> -->
                <div class="fw7" v-html="$t('cardMissions3')"></div>
            </div>
          </div>
        </div>
        <div class="product2-title mt50 disflex flex-between">
          <div class="title fw7">{{$t('Allgames')}}</div>
        </div>
        <div class="list mt50" v-if="!notFound">
          <div class="home1-product2">
            <div class="list-menu al">
              <span class="" v-for="(item,index) in listMenu" @click="getList(item)" :class="{'active':item==isShow}">
                {{item.name}}
              </span>
            </div>
            <div class="product2-content disflex" v-if="list.length>0">
              <div class="list-content" v-for="(item,index) in list">
                <div class="name-title ovhidden" @click="goPlay(item.game_id)">
                  {{item.title}}
                </div>
                <div class="list-img">
                  <img :src="item.icon_image" @click="goPlay(item.game_id)" />
                </div>
                <div class="list-center">
                </div>
                <button class="btn btn-blue" @click="goPlay(item.game_id)">{{$t('play')}}</button>
              </div>
            </div>
            <div class="ac" v-if="list.length>0">
              <router-link :to="{path:'/list'}" class="more db mt50"><span>{{$t('viewAll')}}</span></router-link>
            </div>
          </div>
        </div>
		</div>
    <div class="home-bottom ac mt50">
      <div class="">
        <span class="strong"></span>
        <div class="mission-t mt20" style="font-size:55px;">GAme empire</div>
          <div class="footer-content mt50">
            <router-link class="icon icon1" :to="{path:'/myAccount'}">{{$t('myAccount')}}</router-link>
           <!-- <router-link :to="{path:'/changePassword'}">{{$t('ChangePassword')}}</router-link> -->
            <router-link class="icon icon2" :to="{path:'/faq'}">{{$t('FAQs')}}</router-link>
            <router-link class="icon icon3" :to="{path:'/termsAndCondition'}">{{$t('TC')}} </router-link>
            <router-link class="icon icon4" :to="{path:'/language'}">{{$t('language')}}</router-link>
        </div>
        </div>
      <div class="copyright">{{$t('Copyright')}}</div>
    </div>
	</div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
		Header
    },
    data() {

    return {
			info:{},
      isShow:false,
      keywords:'',
      notFound:false,
      listMenu:[],
			list:[],
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
    if (this.$route.query.msisdn){
      this.getUserLogin()
    }else{
      this.getHome();
      this.getHome2();
      this.getCategory();
    }

	},
    methods: {
      getUserLogin(){
        let that = this
        let data = {
          mobile:this.$route.query.msisdn
        }
         that.$api.post('/api/user/login',data,r =>{
         	that.$parent.returnCode(r,function(){
             if (r.code == 1){
               localStorage.setItem('token',r.data.userinfo.token)
               that.getHome();
               that.getHome2();
               that.getCategory();
             }else{
               this.$router.push({path:'/land'});
             }

         	})

         })
      },
      getHome(){
        let that = this
       // that.$parent.loadModal(true);
        that.$api.post('/api/index/index',null,r =>{
        	that.$parent.returnCode(r,function(){
            that.$parent.loadModal(false);
            that.info = r.data
        	})
        })
      },
      getHome2(){
      	let that =this;
      	//that.$parent.loadModal(true);
        let data = {
          'page':that.page,
          'limit':that.limit,
          'type_id':that.type_id
        }
      	that.$api.post('/api/index/list',data,r =>{
      		that.$parent.returnCode(r,function(){
      			that.$parent.loadModal(false);
      			if(r.data.length>0){
              if(that.page>1){
                that.list = that.list.concat(r.data)
              }else{
                that.list = r.data
              }
      			}else{
      				that.isShow2 = false;
      				//that.$utils.alertText(that.$t('noMore'));
      			}
            console.log(that.list)
          });

      	})
      },
      getCategory(){
        let that = this
        that.$api.post('/api/index/category',null,r =>{
        	that.$parent.returnCode(r,function(){
        		//that.list = r.data.list
        		that.listMenu = r.data
            that.isShow = that.listMenu[0];
        		that.$parent.loadModal(false);
          });

        })
      },
      getList(item){
        this.isShow = item
        this.type_id = item.type_id
        this.list = []
        this.page = 1
        this.getHome2();
      },
      goPlay(game_id){
        this.$router.push({path:'/game',query:{game_id:game_id}});
      },
      getSearch(keywords){
        this.$router.push({path:'/searchList',query:{keywords:this.keywords}});
      },
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/index.vue